<template>
  <div>
    <div class="alert" v-if="saved">All limits are updated successfully.</div>
    <loading :active.sync="isLoading"></loading>

    <table class="table table-bordered table-lg table-v2 table-striped">
      <thead>
      <tr>
        <th>Market</th>
        <th>Special</th>
        <th>Margin %</th>
        <th>Status</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <th colspan="10">
          <a class="btn btn-block btn-outline-info" v-on:click="setMarkets">
            {{ t.save }}
          </a>
        </th>
      </tr>
      <tr v-for="m in markets">
        <td>{{ m.name }}</td>
        <td>{{ m.special }}</td>
        <td class="row-actions" width="100">
          <input type="number" min="100" max="110" v-model="m.oddComplement"/>
        </td>
        <td class="row-actions" width="150">
          <select class="form-control form-control-sm form-control-faded" v-model="m.isDisable">
            <option :value="r.val" v-for="r in status">{{ r.n }}</option>
          </select>
        </td>
      </tr>
      <tr>
        <td colspan="10">
          <a class="btn btn-block btn-outline-info" v-on:click="setMarkets">
            {{ t.save }}
          </a>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
    export default {
        name: 'betMarketSettings',
        props: {
            id: {
                default: 0
            },
            match: {
                default: 0
            },
            live: {
                default: 0
            },
        },
        data () {
            return {
                t: this.$root.t,
                isLoading: true,
                saved: false,
                status: [
                    {val: true, n: 'Disable'},
                    {val: false, n: 'Active'},
                ],
                ranges: [
                    {val: +0.25},
                    {val: +0.20},
                    {val: +0.15},
                    {val: +0.10},
                    {val: +0.05},
                    {val: 0},
                    {val: -0.10},
                    {val: -0.15},
                    {val: -0.20},
                    {val: -0.25},
                    {val: -0.30},
                ],
                markets: []
            }
        },
        watch: {
            'id' () {
                this.fetchMarketData()
            }
        },
        mounted () {
            this.fetchMarketData()
        },
        methods: {
            fetchMarketData () {
                this.$http.get(api+'api/v1/market/settings/'+this.id, {params: {live: this.live, match: this.match, }})
                    .then(response => {

                        this.isLoading = false;
                        this.markets = response.body.result.markets;

                    }, response => {

                    })
            },
            setMarkets() {

                this.saved = false;
                this.isLoading = true;
                this.$http.post(api+'api/v1/market/settings/'+this.id+'?match='+this.match+'&live='+this.live, {markets: this.markets})
                    .then(response => {

                        this.markets = response.body.result.markets;
                        this.isLoading = false;
                        this.saved = true;

                    }, response => {

                        this.saved = false;
                    })

            },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/feed/markets/betMarketSettings.vue